import { config, debug, i18n, inject, LoginAPI, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { georgeWebHeaderStore } from "components/common/GeorgeWebHeader";
import { PdfViewer } from "components/common/PdfViewer";
import authStore from "stores/AuthStore";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { history } from "stores/RouterStore";
import { safeWindowOpen } from "util/helpers";
import { SavingsOptionsOverview } from "./SavingsOptionsOverview";
import { SavingsOptionsRoutes } from "./SavingsOptionsRoutes";
import { SavingsOptionsStore } from "./SavingsOptionsStore";
import { SavingsOptionsSuccess } from "./SavingsOptionsSuccess";


type IProps = RouteComponentProps & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class SavingsOptionsContainer extends React.Component<IProps> {
    store: SavingsOptionsStore;

    constructor(props: any) {
        super(props);
        this.store = new SavingsOptionsStore();
    }

    async componentDidMount() {
        try {
            pushRoute(SavingsOptionsRoutes.ROOT);

            georgeWebHeaderStore.configure({
                title: ui.__("savingsOptions.document.title"),
                backBehaviour: "tokenExchange"
            });

            if (!authStore.authorized) {
                safeWindowOpen(LoginAPI.getLoginUrl("C02345N6", window.location.href));
            } else {
                await this.store.loadData();
            }

        } catch (error) {
            debug.log("### SavingsOptionsContainer.componentDidMount() Failed to load data", error);

            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    render() {
        document.title = ui.__("savingsOptions.document.title");
        return (
            <div>
                <Route exact path={SavingsOptionsRoutes.ROOT} component={this.withStore(SavingsOptionsOverview)} />
                <Route path={SavingsOptionsRoutes.SUCCESS} component={this.withStore(SavingsOptionsSuccess)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/savingsOptions/SavingsOptionsContainer.tsx